import { mapGetters } from 'vuex'
import _throttle from 'lodash/throttle'

export default {
  data() {
    return {
      registered: false, // 是否已注册，默认未注册；因需要确认已注册才可以进入下一个页面
    }
  },
  computed: {
    ...mapGetters(['currentAccount']),
  },

  methods: {
    next: _throttle(
      function () {
        this.$refs['form'].validate((valid) => {
          if (valid && this.registered) {
            this.$store.commit('setCurrentAccount', this.form['email'])
            this.$router.replace({
              path: '/cim/email/detail',
              query: {
                ...this.$route.query,
              },
            })
          } else {
            this.submitDisabled = true
          }
        })
      },
      500,
      { trailing: false }
    ),
  },
}
